var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useCallback, useEffect } from 'react';
import { fetchHelper } from './fetchHelper';
/**
 * This hook should be used when you need data to render a component.
 * It provides helpers for multiple stages of loading remote data as well as a refetch method
 */
export function useFetchEffect(endpoint, options, skip, abortFetchOnCleanup) {
    var _this = this;
    if (options === void 0) { options = {}; }
    if (skip === void 0) { skip = false; }
    if (abortFetchOnCleanup === void 0) { abortFetchOnCleanup = true; }
    var _a = __read(useState(true), 2), isLoading = _a[0], setLoading = _a[1];
    var _b = __read(useState(), 2), error = _b[0], setError = _b[1];
    var _c = __read(useState(), 2), response = _c[0], setResponse = _c[1];
    var _d = __read(useState(0), 2), refetchCount = _d[0], setRefetchCount = _d[1];
    var refetch = useCallback(function () {
        setRefetchCount(function (current) { return current + 1; });
    }, [setRefetchCount]);
    useEffect(function () {
        if (skip) {
            setLoading(false);
            return;
        }
        var controller = new AbortController();
        var signal = controller.signal;
        setError(undefined);
        setLoading(true);
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, response, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetchHelper({ url: endpoint, method: 'GET' }, options, signal)];
                    case 1:
                        _a = _b.sent(), response = _a.response, error = _a.error;
                        if (response) {
                            setResponse(response);
                            setError(undefined);
                        }
                        else if (error) {
                            setError(error);
                            setResponse(undefined);
                        }
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
        return function () {
            abortFetchOnCleanup && controller.abort();
        };
    }, [endpoint, JSON.stringify(options), refetchCount, skip]); // eslint-disable-line
    return [isLoading, response, error, refetch];
}
//# sourceMappingURL=useFetchEffect.js.map